import { render, staticRenderFns } from "./AdminScreens.vue?vue&type=template&id=45f7b630&scoped=true&"
import script from "./AdminScreens.vue?vue&type=script&lang=js&"
export * from "./AdminScreens.vue?vue&type=script&lang=js&"
import style0 from "./AdminScreens.vue?vue&type=style&index=0&id=45f7b630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f7b630",
  null
  
)

export default component.exports